<template>
  <div class="pt-body">
    <div class="productBar">
      <div class="auto clearfix">
        <h2 class="fl">
          产品：大智慧策略投资终端
          <span>非投资咨询类软件产品</span>
        </h2>
        <div class="p-nav fr">
          <span :class="{'cur' :navIndex === index}" @click="selectNav(index)" v-for="(item, index) in nav" :key="index">{{ item }}</span>
        </div>
      </div>
    </div>
    <div class="w1200 ctn-box">
      <div class="gnysCon" v-show="navIndex === 0">
        <div class="header">
          <h1>
            <em>跨越投资新境界</em>
          </h1>
          <div class="btn-box">
            <span class="link-a" @click="goParkate()">立即购买</span>
            <p class="link-btm">RMB 3.8 万元/年</p>
          </div>
        </div>
        <div class="advantage-box">
          <div class="title-box">
            <div class="tle-box">产品优势</div>
            <div class="tle-tip"><span>大智慧沪深京行情 · 多种深度功能展现</span></div>
          </div>
          <div class="adv-list-box">
            <ul class="clearfix adv-list">
              <li class="fl adv-item" v-for="(item,index) in advList">
                <div class="top-b">
                  <em class="icon-box" :class="'i'+(index+1)"></em>
                  <span>{{item.title}}</span>
                </div>
                <div class="btm-text">{{item.titletip}}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="title-box chara-stic">
          <div class="tle-box">特色功能</div>
          <div class="tle-tip"><span>大智慧策略投资终端提供丰富的高端特色行情功能</span></div>
        </div>
        <div class="panel-box">
          <div class="panel-item" v-for="(item,index) in panelList">
            <div class="top-title">
              <span>{{item}}</span>
            </div>
            <div class="img-box">
              <img :src="require('../../assets/images/product/113/V1/img'+(index+1)+'.png')"/>
            </div>
          </div>
        </div>

      </div>
      <div class="xxgnCon" v-show="navIndex === 1">
        <product-detail113/>
      </div>
      <div class="gnysCon" v-show="navIndex === 2">
        <div class="header">
          <h1>
            <em>跨越投资新境界</em>
          </h1>
          <div class="btn-box">
            <span class="link-a" @click="goParkateThree()">立即购买</span>
            <p class="link-btm">RMB 9800元/季度</p>
          </div>
        </div>
        <div class="advantage-box">
          <div class="title-box">
            <div class="tle-box">产品优势</div>
            <div class="tle-tip"><span>大智慧沪深京行情 · 多种深度功能展现</span></div>
          </div>
          <div class="adv-list-box">
            <ul class="clearfix adv-list">
              <li class="fl adv-item" v-for="(item,index) in advList">
                <div class="top-b">
                  <em class="icon-box" :class="'i'+(index+1)"></em>
                  <span>{{item.title}}</span>
                </div>
                <div class="btm-text">{{item.titletip}}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="title-box chara-stic">
          <div class="tle-box">特色功能</div>
          <div class="tle-tip"><span>大智慧策略投资终端提供丰富的高端特色行情功能</span></div>
        </div>
        <div class="panel-box">
          <div class="panel-item" v-for="(item,index) in panelList">
            <div class="top-title">
              <span>{{index==0?'《ACE》最新资金计算模型，捕捉主力埋伏个股。':item}}</span>
            </div>
            <div class="img-box">
              <img :src="require('../../assets/images/product/113/V1/img'+(index+1)+'.png')"/>
            </div>
          </div>
        </div>

      </div>
      <float-bar :id="id" :month="month"/>
    </div>
  </div>
</template>

<script>
import ProductDetail113 from "@/components/product/ProductDetail113.vue";
import FloatBar from "@/components/product/FloatBar.vue";
export default {
  data() {
    return {
      id: this.$parent.id,
      month : 12,
      nav: ["功能演示", "详细功能", "季卡购买"],
      navIndex: 0,
      panelList:[
        '《ACE》活跃资金决策系统，揭示大资金秘密。',
        '《资金先锋》日内资金排头兵，采用DDE+ACE结合的方式体现大资金的参与深度。',
        '《热点轮动》解析市场轮动热点轨迹，智能区分板块龙头股。',
        '《超赢思维》通过两点或三点画线，根据左侧交易理论算法计算生成向上或向下的3个支撑值或压力值',
        '《大数据掘金》潜伏利器，热点关联个股挖掘，关键词智能搜索，让你得选股更轻松',
      ],
      advList:[
        {
          title:'沪深京',
          titletip:'专业的沪深京看盘软件'
        }, {
          title:'板块监控',
          titletip:'领先的板块设置，敏捷触达热点龙头'
        },{
          title:'产业链',
          titletip:'专业研究产业链路，细分上下游关键词 '
        },{
          title:'沪深L2行情',
          titletip:'更深层次分析行情，提供更具实战意义的Level-2数据 '
        },{
          title:'涨停分析',
          titletip:'复盘必备，从昨天强势股中筛选出热门，强者恒强'
        },{
          title:'资金流向',
          titletip:'特色资金计算模型，资金流向结构更精准'
        },{
          title:'董秘互动',
          titletip:'跟踪上市公司董秘互动信息，把握突发投资机会'
        },{
          title:'期待更多',
          titletip:'不断迭代更新新功能，帮助投资者把握市场'
        },
      ]
    };
  },
  created () {
    document.title = "大智慧策略投资终端";
  },
  methods:{
    selectNav(index){
      this.navIndex = index;
      if (index == 2) {
        this.month = 3;
      }
    },
    goParkate () {
      this.$router.push("/order/confirm/113/12?s=official");
    },
    goParkateThree () {
      this.$router.push("/order/confirm/113/3?s=official");
    }
  },
  components: {
    ProductDetail113,
    FloatBar
  }
};
</script>

<style lang="scss" scoped>
$url:'~@/assets/images/product/113/V1/';
.pt-body{
  background-color: #FCFBFF;
  .p-nav span:nth-child(2) {
      margin-right: 25px;
  }
}
.w1200{
  width: 1200px;
  display: block;
  margin: 0 auto;
}
.ctn-box{
  .gnysCon {
    .title-box{
      .tle-box{
        font-size: 40px;
        color: #A100D4;
        text-align: center;
        line-height: 56px;
      }
      .tle-tip{
        padding-top: 13px;
        font-size: 20px;
        color: #333333;
        text-align: center;
        position: relative;
        span{
          position: relative;
          &:before,&:after{
            content: '';
            position: absolute;
            width: 100px;
            height: 1px;
            background-color:#A1A1A1;
            top: 11px;
          }
          &:before{
            left: -130px;
          }
          &:after{
            right: -130px;
          }
        }
      }
    }
    .header{
      @include wh(100%, 400px);
      background: url($url+'banner.png')no-repeat center top/1200px;
      padding-top: 127px;box-sizing: border-box;
      h1{
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 2.4px;
        text-align: center;
        position: relative;
        width: 100%;
        height: 101px;
        box-sizing: border-box;
        line-height: 33px;
        padding-top: 68px;
        background: url($url+'banner-title.png')no-repeat center top/511px;
        em{
          position: relative;
          &:before,&:after{
            content: '';
            position: absolute;
            width: 100px;
            height: 1px;
            background-color: rgba(255,255,255,1);
            top: 13px;
          }
          &:before{
            left: -104.5px;
          }
          &:after{
            right: -104.5px;
          }
        }
      }
      .btn-box{
        text-align: center;
        .link-a{
          cursor: pointer;
          width: 201px;
          height: 54px;
          background-image: linear-gradient(0deg, #A100D4 0%, #CE00EC 100%);
          border-radius: 27px;
          font-size: 22px;
          line-height: 54px;
          display: block;
          margin: 37px auto 0;
          color: #FFFFFF;
          text-align: center;
          position: relative;
          z-index: 1;
          &:before{
            content: '';
            left: 0;
            top: 0;
            position: absolute;
            z-index: -1;
            @include wh(100%, 100%);
            background-color: rgba(255,255,255,0.2);
            pointer-events: none;
            opacity: 0;
            transition: 0.3s all;
            border-radius: 54px;
          }
          &:hover{
            &:before{
              opacity: 1;
            }
          }
        }
        .link-btm{
          font-size: 20px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          padding-top: 4px;
          line-height: 28px;
        }
      }
    }
    .advantage-box{
      padding-top: 53px;
      box-sizing: border-box;
      background: url($url+'bg1.png')no-repeat top center/1200px 100%;

      .adv-list-box{
        margin-top: 48px;
        padding-left: 96px;
        text-align: center;
        .adv-list{
          padding-bottom: 86px;
          text-align: left;
          display: inline-block;
          .adv-item{
            width: 235px;
            height: 142px;
            background: #FFFFFF;
            border: 1px solid rgba(225,216,227,1);
            box-shadow: 0px 18px 18px -12px rgba(0,0,0,0.05);
            border-radius: 4px;
            margin-right: 20px;
            box-sizing: border-box;
            margin-bottom: 30px;
            padding: 20px 13px;
            &:nth-child(4n+4){margin-right: 0;}
            .top-b{
              display: flex;
              .icon-box{
                display: inline-block;
                width: 40px;
                height: 40px;
                margin-right: 14px;
                background:url($url+'icons.png')no-repeat  ;
                background-size: 48px;
                &.i1{
                  background-position: 0px 0px;
                }
                &.i2{
                  background-position: 0px -60px;
                }
                &.i3{
                  background-position: 0px -120px;
                }
                &.i4{
                  background-position: 0px -180px;
                }
                &.i5{
                  background-position: 0px -240px;
                }
                &.i6{
                  background-position: 0px -300px;
                }
                &.i7{
                  background-position: 0px -360px;
                }
                &.i8{
                  background-position: 0px -420px;
                }
              }
              span{
                font-size: 22px;
                line-height: 40px;
                color: #333333;
              }
            }
            .btm-text{
              font-size: 16px;
              color: rgba(51,51,51,0.60);
              padding-top: 14px;
            }
          }
        }
      }
    }
    .chara-stic{
      height: 196px;
      padding-top: 45px;
      box-sizing: border-box;
      background: url($url+'charastic.png')no-repeat center top/1200px;
      .tle-box{
        color: #fff;
      }
      .tle-tip{
        color: #fff;
        span{
          &:before,&:after{
            background-color:#fff;
          }
        }
      }
    }
    .panel-box{
      .panel-item{
        margin-bottom: 20px;
        padding:79px 95px;
        background-color: #fff;
        .top-title{
          padding-left: 25px;
          position: relative;
          margin-bottom: 15px;
          margin-left: 5px;
          &:before{
            content: '';
            width: 16px;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background-color: #A100D4 ;
            transform: skewX(-11deg);
          }
          span{
            position: relative;
            width: fit-content;
            display: block;
            z-index: 1;
            font-size: 20px;
            color: #FFFFFF;
            padding: 10px 30px;
            box-sizing: border-box;
            &:before{
              content: '';
              height: 100%;
              position: absolute;
              left: 0;
              z-index:-1;
              top: 0;
              background-color: #A100D4 ;
              transform: skewX(-11deg);
              width: 100%;
              position: absolute;
              right: 0;
            }
          }
        }
        .img-box{
          img{}
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/Product113.vue